"use client";

import { useScrollReveal } from "@/hooks/common/useScrollReveal";
import { consumerAffairsLogo, newsweekLogo } from "@/lib/gcsImagePaths";
import { realtorLogo, usaTodayLogo } from "@/lib/gcsImagePaths";

import { washingtonPostLogo } from "@/lib/gcsImagePaths";

import { cn } from "@/lib/utils";
import GcsImage from "./GcsImage";
import { consumerAffairsLogoDim } from "@/lib/communityData";
import { newsweekLogoDim, realtorLogoDim } from "@/lib/communityData";
import { usaTodayLogoDim, washingtonPostLogoDim } from "@/lib/communityData";

export interface AsFeaturedProps {
  title?: string;
  className?: string;
}

export default function AsFeatured({
  title = "AS FEATURED IN",
  className,
}: AsFeaturedProps) {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section
      ref={ref}
      className={cn(
        `py-12 bg-background mb-2 w-full transition-opacity duration-1000 ${
          isVisible ? "opacity-100" : "opacity-0"
        }`,
        className,
      )}
      style={{
        // Reserve space to prevent CLS - content is always in layout
        visibility: isVisible ? "visible" : "hidden",
      }}
    >
      <div className="container mx-auto px-4">
        <h3 className="text-center text-lg font-semibold text-muted-foreground mb-8">
          {title}
        </h3>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
          <a
            href="https://www.consumeraffairs.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-opacity hover:opacity-70"
          >
            <GcsImage
              path={consumerAffairsLogo}
              width={consumerAffairsLogoDim.width}
              height={consumerAffairsLogoDim.height}
              alt="Consumer Affairs"
              className="h-9 w-auto object-contain"
              priority
            />
          </a>
          <a
            href="https://www.newsweek.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-opacity hover:opacity-70"
          >
            <GcsImage
              path={newsweekLogo}
              width={newsweekLogoDim.width}
              height={newsweekLogoDim.height}
              alt="Newsweek"
              className="h-[1.65rem] w-auto object-contain"
            />
          </a>
          <a
            href="https://www.realtor.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-opacity hover:opacity-70"
          >
            <GcsImage
              path={realtorLogo}
              width={realtorLogoDim.width}
              height={realtorLogoDim.height}
              alt="Realtor.com"
              className="h-8 w-auto object-contain"
            />
          </a>
          <a
            href="https://www.usatoday.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-opacity hover:opacity-70"
          >
            <GcsImage
              path={usaTodayLogo}
              width={usaTodayLogoDim.width}
              height={usaTodayLogoDim.height}
              alt="USA Today"
              className="h-8 w-auto object-contain"
            />
          </a>
          <a
            href="https://www.washingtonpost.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-opacity hover:opacity-70"
          >
            <GcsImage
              path={washingtonPostLogo}
              width={washingtonPostLogoDim.width}
              height={washingtonPostLogoDim.height}
              alt="The Washington Post"
              className="h-8 w-auto object-contain"
            />
          </a>
        </div>
      </div>
    </section>
  );
}
